export function normalizeSignUpEmail(email: string | null | undefined): string {
  if (typeof email !== 'string') {
    return '';
  }

  const normalizedEmail = email.trim().toLowerCase();
  const atIndex = normalizedEmail.indexOf('@');

  if (atIndex <= 0 || atIndex === normalizedEmail.length - 1) {
    return normalizedEmail;
  }

  const localPart = normalizedEmail.slice(0, atIndex);
  const domain = normalizedEmail.slice(atIndex + 1);
  const plusIndex = localPart.indexOf('+');

  if (plusIndex <= 0) {
    return normalizedEmail;
  }

  return `${localPart.slice(0, plusIndex)}@${domain}`;
}
